// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
import './assets/css/common.css'

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;


import Bus from './utils/bus'
import "@/utils/el-input"
Vue.prototype.$bus = Bus

if(process.env.NODE_ENV!='development'){
  const url = process.env.BASE_API;
  axios.defaults.baseURL = url;
}
Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

//登录信息失效跳转到登录页
axios.interceptors.response.use( (response)=> {
  if(response.data.code == '-1') {
    localStorage.setItem("userInfo", "");
    localStorage.removeItem('logintoken')
    localStorage.setItem('path','/dashboard/Dashboard')
    setTimeout(function () {
      window.location.href = '/'
    },1000)
  }
  return response;
},  (error)=> {
  return Promise.reject(error);
});

// Vue.mixin({
//   beforeRouteLeave(to, from, next) {
//     // 存在关闭key 则清除缓存
//     // let key = targetClosePath
//     let cache = this.$vnode.parent.componentInstance.cache // 缓存的组件
//     let keys = this.$vnode.parent.componentInstance.keys // 缓存的组件名
//     console.log(cache,keys)
//     // if (cache[key] !== null) {
//     //   delete cache[key]
//     //   let index = keys.indexOf(key)
//     //   if (index > -1) {
//     //     keys.splice(index, 1)
//     //   }
//     // }
//     next()
//   }
// })

// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("userInfo"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (Boolean(localStorage.getItem("userInfo"))) { // 判断是否登录
                if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
                    next();
                } else {
                    /**
                     * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
                     */
                    next({
                        path: '/dashboard/Dashboard'
                    })
                    localStorage.setItem('path','/dashboard/Dashboard')
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js